import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-[#1a1c1b]">
      <Header />
      
      <main className="pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-5 md:px-10">
          <h1 className="text-3xl md:text-4xl font-black text-[#d9fb06] uppercase mb-8">
            Privacy Policy
          </h1>
          
          <div className="prose prose-invert max-w-none space-y-6 text-[#888680]">
            <p className="text-sm">Last updated: February 2025</p>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">1. Information We Collect</h2>
              <p>We collect information you provide directly to us, including:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Contact information (name, email address, phone number)</li>
                <li>Account information related to your dispute (platform, account handle/URL)</li>
                <li>Details about your account suspension or dispute</li>
                <li>Payment information processed through third-party providers</li>
                <li>Communications with us</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">2. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide, maintain, and improve our services</li>
                <li>Prepare and submit dispute documentation on your behalf</li>
                <li>Communicate with you about your case</li>
                <li>Process payments</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">3. Information Sharing</h2>
              <p>We may share your information with:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Social media platforms as part of dispute submission process</li>
                <li>Legal professionals who may review or prepare documentation</li>
                <li>Service providers who assist in our operations</li>
                <li>As required by law or to protect our rights</li>
              </ul>
              <p className="mt-4">We do not sell your personal information to third parties.</p>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">4. Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal 
                information. However, no method of transmission over the Internet is 100% secure.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">5. Data Retention</h2>
              <p>
                We retain your information for as long as necessary to provide our services and comply 
                with legal obligations. You may request deletion of your data by contacting us.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">6. Your Rights</h2>
              <p>Depending on your location, you may have rights to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access your personal information</li>
                <li>Correct inaccurate information</li>
                <li>Delete your information</li>
                <li>Object to processing</li>
                <li>Data portability</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">7. Cookies and Tracking</h2>
              <p>
                We use cookies and similar technologies to analyze website traffic and improve user 
                experience. This includes Google Analytics and Microsoft Clarity. You can manage 
                cookie preferences through your browser settings.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-bold text-[#dfddd6] mt-8 mb-4">8. Contact Us</h2>
              <p>For privacy-related inquiries, contact us at:</p>
              <p className="text-[#dfddd6]">
                Email: intake@socialdisputeco.com<br />
                Phone: 808-301-2134
              </p>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
